'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.demand_monitoring', {
    template: '<demand-monitoring></demand-monitoring>'
  }).state('main.demand_monitoring.daily_report', {
    url: 'demand_monitoring/:id',
    views: {
      inst_active_power: {
        template: '<demand-detail></demand-detail>'
      }
    }
  });
};



// WEBPACK FOOTER //
// ./public/dev/app/demand/monitoring/demand_monitoring.routes.js